module.exports = __webpack_public_path__ + "media/flags/002-belgium-76ffed56.svg";